import { NgModule } from '@angular/core'
import { AccordionModule } from '@vg-constellation/angular-18/accordion'
import { ButtonModule } from '@vg-constellation/angular-18/button'
import { CheckboxModule } from '@vg-constellation/angular-18/checkbox'
import { DropdownModule } from '@vg-constellation/angular-18/dropdown'
import { IconModule } from '@vg-constellation/angular-18/icon'
import { LinkModule } from '@vg-constellation/angular-18/link'
import { ModalDialogModule } from '@vg-constellation/angular-18/modal-dialog'
import {
  SegmentComponent,
  SegmentedControlComponent,
  SegmentedControlModule,
  SegmentInputComponent,
} from '@vg-constellation/angular-18/segmented-control'
import {
  SelectComponent,
  SelectInputComponent,
} from '@vg-constellation/angular-18/select'
import { SpinnerComponent } from '@vg-constellation/angular-18/spinner'
import { SwitchModule } from '@vg-constellation/angular-18/switch'
import {
  TabPanelDirective,
  TabsComponent,
} from '@vg-constellation/angular-18/tabs'
import { TooltipModule } from '@vg-constellation/angular-18/tooltip'

const constellationModules = [
  ButtonModule,
  CheckboxModule,
  ModalDialogModule,
  IconModule,
  SpinnerComponent,
  SwitchModule,
  TooltipModule,
  AccordionModule,
  LinkModule,
  DropdownModule,
  TabPanelDirective,
  TabsComponent,
  SelectComponent,
  SelectInputComponent,
  SegmentInputComponent,
  SegmentComponent,
  SegmentedControlComponent,
  SegmentedControlModule,
]

@NgModule({
  imports: [...constellationModules],
  declarations: [],
  providers: [],
  exports: [...constellationModules],
})
export class ConstellationModule {}
